import React from "react";
import { View, StyleSheet, ScrollView } from "react-native";

// Components
import Stories from "../components/today/Stories";
import Tasks from "../components/today/Tasks";
import Watchlist from "../components/today/Watchlist";

// Styles
import { Colors, Spacing } from "../styles";

const Today = () => {
  return (
    <ScrollView style={styles.container} showsVerticalScrollIndicator={false}>
      <Stories />

      <View style={styles.inner}>
        <Tasks />
        <Watchlist />
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.plum900,
  },
  inner: {
    padding: Spacing.page,
    paddingTop: 0,
  },
});
export default Today;
